<div class="main-console-container" >

  <div class="row">
    <div class="col-md-6">
      <div class="main-console-title">
        {{niceOtpName}} One-Time Passcode
      </div>
    </div>

    <div class="col-md-6">
      <div class="main-console-card">

        <div class="h-100" *ngIf="multiFactor">
          <app-multi-credentials class="h-100" [errorMsg]="errorMsg" [credentialOptions]='otpOptions' buttonLabel='Continue'
                                 (selectedCredential)="selectedCredential($event)"></app-multi-credentials>
        </div>

        <form *ngIf="!multiFactor" class="h-100" [formGroup]="verifyOtpForm" novalidate
              [style.visibility]="ready? 'visible' : 'hidden'">

          <div>
            <app-errormsg id="otp-input-errors" [errorDiv]="errorDiv" [errorMsg]="errorMsg"></app-errormsg>
            <div>
              <div *ngIf="otpSent">
                <span id="credential-otp-sent-with-tag" *ngIf="credMetaDataTag else credentialOtpSentNoTag">
                  <span class="align-middle">
                    Enter security code sent to {{selectedCredValue}} 
                    <fa-icon [icon]="getIconForTag(credMetaDataTag)" class="pe-2"></fa-icon>
                  </span>
                  <img src="assets/img/help-icon.svg" title="One-time passcode sent via {{getTitleForTag(this.credMetaDataTag)}} {{niceOtpName}}" alt="Passcode delivery method"
                     class="tooltip-icon"/> 
                </span>
                <ng-template id="credential-otp-sent-with-no-tag" #credentialOtpSentNoTag>
                  <span class="align-middle">Enter security code sent to {{selectedCredValue}}</span>
                  <img src="assets/img/help-icon.svg" title="One-time passcode sent via {{niceOtpName}}" alt="Passcode delivery method"
                     class="tooltip-icon"/>
                </ng-template>
              

              </div>
              <span class="visible align-middle" *ngIf="!otpSent">
                <span id="credential-otp-sending-with-tag" *ngIf="credMetaDataTag else credentialOtpSentNoTag">
                  <span class="align-middle">
                    Sending security code to {{selectedCredValue }} <fa-icon [icon]="getIconForTag(credMetaDataTag)" [title]="getTitleForTag(credMetaDataTag)" class="pe-2"></fa-icon> . . .
                  </span>
                </span>
                <ng-template id="credential-otp-sending-with-no-tag" #credentialOtpSentNoTag>
                  <span class="align-middle">Sending security code to {{selectedCredValue}} . . .</span>
                </ng-template>
              </span>
            </div>
          </div>

          <div class="row" *ngIf="otpSent">
            <app-otp-input (otpEntryChange)="onOtpEntryChange($event)"></app-otp-input>
          </div>
          <div class="mt-2" *ngIf="otpSent">
            <small *ngIf="credType === 'email'">You will receive email from "noreply-bnym-otp@verify.bny.com" or "noreply-bnym-otp@bnymellon.com". It contains your verification code. You may have to check your spam folders. Your organization may have additional policies or spam filters, that may need adjustments, to prioritize emails from those senders.</small>
            <small *ngIf="credType === 'sms'">You will receive an SMS message from "Twilio Verify" on your mobile phone. The sender may appear by its short code. The message contains the verification code.</small>
            <small *ngIf="credType === 'ivr'">You will receive a phone call from "Twilio Verify". If caller ID is not available, it may appear as unknown caller. Please, follow the prompts, listen and enter your verification code.</small>
          </div>
          <app-remember-device *ngIf="!isRegisterFlow"></app-remember-device>
          <div class="row mt-3">
            <div class="col" *ngIf="resendEnabled">
              <button type="submit" class="primary-btn" (click)="onResendOTP()">
                <fa-icon [icon]="resendIcon" class="pe-2 text-white" title="Resend Icon"></fa-icon>
                Resend
              </button>
            </div>
            <div class="col ms-auto" *ngIf="factorSelection">
              <button class="secondary-btn" (mousedown)="onBack()" *ngIf="factorSelection">
                More Options
              </button>
            </div>
          </div>

          <div>
            <app-userinfo></app-userinfo>
            <app-loading *ngIf="!ready && !errorDiv"></app-loading>
          </div>

        </form>

      </div>
    </div>
  </div>
</div>